const React = require("react");
const { NavLink, Outlet } = require("react-router-dom");
const { usePrintify } = require("../context/PrintifyContext");
const { getPrintifyNavigation } = require("../navigation");
const { PRINTIFY_CSS } = require("../styles");
const h = React.createElement;

const PrintifyLayout = () => {
  const { t, isAdmin } = usePrintify();
  return h("div", { className: "pyds-shell" }, h("style", null, PRINTIFY_CSS),
    h("header", { className: "pyds-top" }, h("h1", null, t("h_printify_title", "Printify Dropshipping")), h("p", null, t("h_printify_subtitle", "Connect shops, import print-on-demand products and automate fulfillment."))),
    h("nav", { className: "pyds-nav", "aria-label": t("h_printify_navigation", "Printify navigation") }, ...getPrintifyNavigation(t, { isAdmin }).map((item) => h(NavLink, { key: item.to, to: item.to, className: ({ isActive }) => isActive ? "active" : "" }, item.label))),
    h("main", { className: "pyds-main" }, h(Outlet))
  );
};
module.exports = { PrintifyLayout };
